import { FilterStore } from 'page/catalog/store/FilterStore'

export type Option = {
  value: string
  label?: string
  group?: string
}

export function toggleOption(key: string, value: string[], options: Option[]): string[] {
  const option = options.find(o => o.value === key)
  if (!option) return value

  const { label, group } = option
  const keys = options.filter(o => o.label === label && o.group === group).map(o => o.value)
  const has = value.some(k => keys.includes(k))
  const next = has
    ? value.filter(k => !keys.includes(k))
    : [...value, ...keys]
  return next
}

function getOptionFullName(options: Option[], value: string) {
  const option = options.find(o => o.value === value)
  if (!option) return value
  const { group, label } = option
  return [group, label].filter(s => s).join(' > ')
}

export function getFilterCount(filter: FilterStore, options: Option[]) {
  return new Set(filter.value.map(it => getOptionFullName(options, it))).size
}
